// Ubicación en el repo: src/lib/format.js
export function formatPatientName(p) {
  // Resguardo agregado 22-ago-2026 (fix #8 de la auditoría, DECISIONS.md) —
  // antes rompía si se llamaba con null/undefined; funcionaba solo porque
  // todos los llamados existentes ya verificaban antes. Mismo patrón que
  // formatProfessionalName.
  if (!p) return '';
  return [p.nombre, p.segundo_nombre, p.apellido, p.segundo_apellido].filter(Boolean).join(' ');
}

export function calculateAge(birthdate) {
  if (!birthdate) return null;
  const today = new Date();
  const born = new Date(birthdate + 'T00:00:00');
  let age = today.getFullYear() - born.getFullYear();
  const m = today.getMonth() - born.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < born.getDate())) age--;
  return age;
}

export function formatDate(value) {
  if (!value) return '—';
  // Si es una fecha "date" pura (YYYY-MM-DD, sin hora — como purchase_date,
  // exam.date, control.date, etc.), hay que parsearla a mano en hora local.
  // `new Date('YYYY-MM-DD')` la interpreta como medianoche UTC, y en Chile
  // (UTC-3/UTC-4) eso cae en el día anterior al mostrarla con
  // toLocaleDateString — mismo bug de fondo que ya se evitó en
  // todayISO()/addDaysISO() (ver DECISIONS.md #18 punto 4), pero acá se
  // había colado de nuevo. Para timestamps completos (created_at, etc.,
  // que sí traen hora/offset) el parseo normal sigue funcionando bien.
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  let d;
  if (dateOnly) {
    const [y, m, day] = value.split('-').map(Number);
    d = new Date(y, m - 1, day);
  } else {
    d = new Date(value);
  }
  return d.toLocaleDateString('es-CL');
}

export function formatCurrency(value) {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value);
}

export function formatProfessionalName(prof, { withRole = false } = {}) {
  if (!prof) return 'Sin asignar';
  const name = [prof.nombre, prof.apellido].filter(Boolean).join(' ');
  return withRole && prof.role ? `${name} (${prof.role})` : name;
}

// Fecha de HOY en formato YYYY-MM-DD usando componentes locales — NUNCA
// `new Date().toISOString().slice(0,10)` (eso da la fecha en UTC, que en
// Chile puede ser el día siguiente/anterior según la hora — exactamente
// el bug ya corregido en el prototipo, ver DECISIONS.md #18 punto 4).
export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function addDaysISO(iso, delta) {
  const [y, m, d] = iso.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  date.setDate(date.getDate() + delta);
  const yy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

// Fecha + hora corta para timestamps (created_at, etc.) — usado en
// BranchNotes.jsx para mostrar "cuándo" se publicó cada aviso.
export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  return `${d.toLocaleDateString('es-CL')} ${d.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}`;
}

// Con año explícito (agregado 20-ago-2026, DECISIONS.md #74) — antes no lo
// traía, y con el auto-agendamiento público (donde se puede reservar hasta
// 30 días adelante, cruzando fin de año en diciembre) quedaba ambiguo.
// Afecta también al comprobante de cita y al encabezado de Agenda por
// día — se corrige acá centralizado en vez de solo en la página pública,
// para que ambos lugares muestren siempre la misma fecha completa.
export function formatDateLong(iso) {
  const [y, m, d] = iso.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return date.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
}
